<template>
  <div class="mt-4">
    <safe-icon class="align-middle" />
    <span class="align-middle inline-block ml-1 text-lg" style="color: #808490">手机号授权</span>
    <span class="block mt-2 text-gray-400 text-sm w-full md:w-1/3 ">{{ desc }}</span>

    <span v-if="type === 'agreed'" class="status success">
      <right-icon class="inline-block" style="margin-top: -2px" />
      已成功授权
    </span>

    <span v-else-if="type === 'refused'" class="status error">
      已拒绝授权
    </span>

    <div v-show="visible" class="modal">
      <div class="mask"></div>
      <div class="modal-content">
        <div class="modal-title">手机号授权</div>
        <div class="modal-body">
          <div class="modal-body-main">
            <span class="text-lg mb-2 block">{{ mainBody }} 申请获得</span>
            <span class="desc">{{ desc }}</span>
            <div class="modal-phone">
              <input
                v-model="phone.value"
                class="ipt-phone border-transparent"
                :class="{
                  rounded: !defaultPhone,
                  'rounded-tl': defaultPhone,
                  'rounded-bl': defaultPhone
                }"
                :style="{
                  width: !userInfo || !userInfo.phone ? '100%' : 'calc(100% - 120px)'
                }"
                type="tel"
                placeholder="请输入手机号"
              />
              <span
                class="ipt-phone-addon-after"
                :style="{ right: !userInfo || !userInfo.phone ? '20px' : '140px' }"
                @click="onClear"
              ></span>
              <button v-if="defaultPhone" class="btn-phone__auto" @click="onGetDefaultPhone">
                获取注册手机号
              </button>
            </div>
          </div>

          <div class="button-group">
            <button class="btn cancel" @click="onCancel">拒绝</button>
            <button class="btn ok" @click="onOk">允许</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import RightIcon from './assets/RightIcon.vue';
import SafeIcon from './assets/SafeIcon.vue';
import { UtteranceControl } from '@/components/resources';
import { namespace } from 'vuex-class';
import { Auth, AuthStatus, UserInfo } from '@/store/modules/common/types';
import { Content } from '@forchange/storytime';
import { INVALID_PHONE_MSG } from '@/utils/constant';

const userModule = namespace('common');

@Component({
  components: {
    RightIcon,
    SafeIcon,
    UtteranceControl
  }
})
export default class PhoneAuth extends Vue {
  @Prop({ type: Object })
  content!: Content & {
    desc?: string;
    mainBody?: string;
  };

  @userModule.State('userInfo') public userInfo: UserInfo;

  @userModule.State('auth') public auth!: Auth;

  type: AuthStatus = '';
  phone = {
    error: false,
    value: ''
  };
  visible = true;

  @Watch('auth.phone.status', { immediate: true })
  phoneAuthChanged(value: AuthStatus, oldValue: AuthStatus) {
    if (value !== '') {
      this.visible = false;
      this.type = value;
    }
  }

  @Watch('content.input', { immediate: true })
  inputChange(value: any) {
    console.log('>>>input', value);
    if (value) {
      this.type = value;
      this.visible = false;
    }
  }

  get defaultPhone() {
    return this.userInfo && this.userInfo.phone;
  }

  get desc() {
    return (
      this.content?.desc || '当前授权仅获取您填写的手机号，用作课程运营方对课程质量回访，客诉跟进。'
    );
  }

  get mainBody() {
    return this.content?.mainBody || '风变课灵小馆';
  }

  onClear() {
    this.phone.value = '';
  }

  changeControlStatus(status: AuthStatus) {
    this.$store.commit('common/setAuth', {
      key: 'phone',
      status
    });

    window.$tracker?.authPhone({
      resource_id: this.content.$id,
      desc: this.desc,
      mainBody: this.mainBody,
      status: status as 'agreed' | 'refused',
      phone: status === 'agreed' ? this.phone.value : ''
    });
  }

  onCancel() {
    this.visible = false;
    this.type = 'refused';
    this.changeControlStatus('refused');
    window.storyteller.input('refused');
  }

  onOk() {
    if (!/^(?:(?:\+|00)86)?1\d{10}$/.test(this.phone.value.trim())) {
      this.phone.error = true;
      this.$Message.error({ content: INVALID_PHONE_MSG, time: 3000 });
      return;
    }

    this.phone.error = false;
    this.visible = false;
    this.type = 'agreed';
    this.changeControlStatus('agreed');
    window.storyteller.input('agreed');
  }

  onGetDefaultPhone() {
    this.phone.value = this.defaultPhone;
  }
}
</script>

<style scoped>
/* .modal {
} */
.status {
  @apply text-white py-1 px-2 mt-2 w-1/3 block rounded-md text-sm md:w-1/5;
}
.status.success {
  @apply bg-green-500;
}
.status.error {
  @apply bg-red-500;
}

.mask {
  @apply bg-black absolute left-0 right-0 top-0 bottom-0 opacity-30;
}
.divide {
  @apply block bg-gray-200 my-2;
  height: 1px;
}

.modal-content {
  @apply w-full bg-white p-6 box-border rounded-t-lg flex flex-col absolute left-0 bottom-0 transform z-20;
  min-height: 300px;
}

.modal-content .modal-body {
  @apply flex flex-col;
  height: 220px;
}
.modal-content .modal-body-main {
  @apply flex-1;
}
.modal-content .modal-title {
  @apply text-2xl text-gray-800 font-bold mb-6;
}
.modal-content .desc {
  @apply text-gray-500 block;
}

.modal-content .modal-phone {
  @apply relative  mt-6;
}
.modal-content .ipt-phone {
  @apply bg-gray-100 pr-2 pl-4 py-3 relative;
  height: 44px;
  /* width: ; */
}
.modal-content .ipt-phone:placeholder-shown + .ipt-phone-addon-after {
  @apply hidden;
}
.modal-content .modal-phone .btn-phone__auto {
  @apply absolute py-3 bg-gray-200 right-0 rounded-tr rounded-br;
  width: 120px;
  height: 44px;
}
.modal-content .ipt-phone-addon-after {
  @apply absolute top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full bg-no-repeat bg-center box-border inline-block cursor-pointer z-20;
  width: 16px;
  height: 16px;
  background-image: url('../../../select-menu/assets/close.svg');
  background-size: 50%;
}

.button-group {
  @apply flex justify-around w-full;
}
.button-group .btn {
  @apply border-gray-400 font-normal;
  width: 160px;
}
.button-group .btn:hover {
  @apply opacity-90;
}
.button-group .btn.cancel {
  @apply bg-gray-200;
}
.button-group .btn.ok {
  @apply bg-motif-500 text-white;
}

@screen md {
  .modal-content {
    @apply rounded-lg left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2;
    width: 440px;
  }

  .modal-content .modal-body {
    height: 320px;
  }
}
</style>
